// Module
var code = `<section class="page-body default-content">

  <h2>Select Dropdowns</h2>
  <p>
    Selects allow users to choose from a predefined list of options.
    SpyneJS styles selects with consistent padding, a custom arrow icon, focus rings,
    and validation states for accessibility.
  </p>

  <!-- Default -->
  <h3>Default Select</h3>
  <div class="form-examples">
    <label class="select" for="select-default">Options</label>
    <select id="select-default">
      <option>Option 1</option>
      <option>Option 2</option>
      <option>Option 3</option>
    </select>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label class="select" for="select-default"&gt;Options&lt;/label&gt;
&lt;select id="select-default"&gt;
  &lt;option&gt;Option 1&lt;/option&gt;
  &lt;option&gt;Option 2&lt;/option&gt;
  &lt;option&gt;Option 3&lt;/option&gt;
&lt;/select&gt;
    </code></pre>
  </div>

  <!-- Focus -->
  <h3>Focus State</h3>
  <div class="form-examples">
    <label class="select" for="select-focus">Focused</label>
    <select id="select-focus">
      <option selected>Focused option</option>
      <option>Another option</option>
    </select>
  </div>

  <!-- Disabled -->
  <h3>Disabled Select</h3>
  <div class="form-examples">
    <label class="select" for="select-disabled">Disabled</label>
    <select id="select-disabled" disabled>
      <option>Option A</option>
      <option>Option B</option>
    </select>
  </div>

  <!-- Validation -->
  <h3>Validation States</h3>
  <p>
    Apply <code>.success</code> or <code>.error</code> classes directly to selects
    for validation feedback. Include hint text for accessibility.
  </p>
  <div class="form-examples">
    <div>
      <label class="select" for="select-success">Success</label>
      <select id="select-success" class="success">
        <option selected>✓ Valid choice</option>
        <option>Other choice</option>
      </select>
      <div class="input-hint success">✓ Selection is valid</div>
    </div>
    <div>
      <label class="select" for="select-error">Error</label>
      <select id="select-error" class="error">
        <option selected>✕ Invalid choice</option>
        <option>Other choice</option>
      </select>
      <div class="input-error-label">✕ Please choose another option</div>
    </div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label class="select" for="select-success"&gt;Success&lt;/label&gt;
&lt;select id="select-success" class="success"&gt;
  &lt;option selected&gt;✓ Valid choice&lt;/option&gt;
  &lt;option&gt;Other choice&lt;/option&gt;
&lt;/select&gt;
&lt;div class="input-hint success"&gt;✓ Selection is valid&lt;/div&gt;

&lt;label class="select" for="select-error"&gt;Error&lt;/label&gt;
&lt;select id="select-error" class="error"&gt;
  &lt;option selected&gt;✕ Invalid choice&lt;/option&gt;
  &lt;option&gt;Other choice&lt;/option&gt;
&lt;/select&gt;
&lt;div class="input-error-label"&gt;✕ Please choose another option&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always provide a <code>&lt;label&gt;</code> associated with the select for clarity.</li>
    <li>Ensure focus rings remain visible for keyboard users.</li>
    <li>Provide meaningful option labels — avoid “Option 1/2/3” in real-world use.</li>
    <li>Use validation hint text so feedback isn’t communicated by color alone.</li>
  </ul>

  <!-- Back link -->
  <p>
    <a class="route-link" data-channel="ROUTE"
       data-page-id="elements" data-topic-id="forms" data-option-id=""
       href="/elements/forms">← Back to Forms Overview</a>
  </p>

</section>
`;
// Exports
module.exports = code;